import { useEffect } from "react";

export default function useTitleHook(title: string) {
    useEffect(() => {
        document.title = 'Result Gate - ' + title;
    }, [title]);
}